export default "__VITE_ASSET__DPbW0crR__"